import { OWED_BALANCE_FROM } from './owed-balance-from.js';
import { SalesOrderStatus } from './sales-order-status.js';
// "Pending Payment" is defined once here so the stats resolver (apps/api) and the list
// where-builder (apps/web) can't drift apart on what counts as pending payment -- previously
// each side independently hardcoded the status AND balanceDue > 0. Delivered, since a Shipped order is not owed yet.
// The API's PENDING_PAYMENT_WHERE adds the Credit Return exclusion, which the web's where can't express.
export const PENDING_PAYMENT_STATUS_ID = SalesOrderStatus.DELIVERED;
// The cents form of "not isSalesOrderBalancePaid": half a cent rounds up to a cent still owed.
export const PENDING_PAYMENT_BALANCE_DUE_FILTER = { gte: Number(OWED_BALANCE_FROM) };
//# sourceMappingURL=sales-order-pending-payment.js.map